import { all, fork } from "redux-saga/effects";
import onBoardingSaga from "../screens/onBoarding/onBoardingSaga";
import ProjectSaga from "../screens/Projects/ProjectSaga";
import ProjectUnitSaga from "../screens/ProjectsUnit/ProjectUnitSaga";
import BookingSaga from "../screens/Booking/BookingSaga";


export function* rootSaga() {
    yield all([fork(onBoardingSaga)]);
    yield all([fork(ProjectSaga)]);
    yield all([fork(ProjectUnitSaga)]);
    yield all([fork(BookingSaga)]);
}